import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";
import { getSubscriptionApiClient } from "@shared/apis/sidekick/api-factories";
import { GetSubscriptionStatusResponse } from "@shared/apis/sidekick/generated";
import {
  ApiError,
  apiResponseErrorHandler,
} from "@shared/apis/sidekick/api-error-handler";

export const GET_SUBSCRIPTION_STATUS_QUERY_KEY = "subscription-status";

type Props = {
  onSuccess?: (data: GetSubscriptionStatusResponse) => void;
  onError?: (error: ApiError) => void;
  enabled: boolean;
};

const REFETCH_INTERVAL = 1000 * 60 * 5; // 5 minutes

export const useGetSubscriptionStatus = (props: Props) => {
  const { enabled } = props;
  const api = getSubscriptionApiClient();
  const query = useQuery({
    queryKey: [GET_SUBSCRIPTION_STATUS_QUERY_KEY],
    queryFn: async () => {
      try {
        const data =
          await api.subscriptionControllerGetUserSubscriptionStatus();
        props?.onSuccess?.(data);
        return data;
      } catch (e) {
        console.error(`Error trying to fetch the subscription status`, e);
        const error = await apiResponseErrorHandler(e);
        props?.onError?.(error);
        throw error;
      }
    },
    enabled,
    retry: 2,
    refetchInterval: REFETCH_INTERVAL,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
  });

  return extractQueryState(query);
};
